import axios from 'axios'
import router from '@src/router'

export default {
  namespaced: true,
  state: {
    authenticated: false,
    user_authenticated: false,
    user: {},
    user_frontend: {},
    guest: {},
    sport: null
  },
  getters: {
    authenticated(state) {
      return state.authenticated
    },
    user_authenticated(state) {
      return state.user_authenticated
    },
    user(state) {
      return state.user
    },
    user_frontend(state) {
      return state.user_frontend
    },
    guest(state) {
      return state.guest
    },
    sport(state) {
      return state.sport
    }
  },
  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value
    },
    SET_USER_AUTHENTICATED(state, value) {
      state.user_authenticated = value
    },
    SET_USER(state, value) {
      state.user = value
    },
    SET_USER_FRONTEND(state, value) {
      state.user_frontend = value
    },
    SET_GUEST(state, value) {
      state.guest = value
    },
    SET_SPORT(state, value) {
      state.sport = value
    }
  },
  actions: {
    login({ commit }) {
      return axios.get('/api/user').then(({ data }) => {
        commit('SET_USER', data)
        commit('SET_AUTHENTICATED', true)
        commit('SET_SPORT', data.type_web)
        if (data.type_web == 'padel') {
          router.push({ name: 'PadelBookingList' })
        } else {
          router.push({ name: 'BookingList' })
        }
      }).catch(({ response: { data } }) => {
        commit('SET_USER', {})
        commit('SET_AUTHENTICATED', false)
      })
    },
    async user_login({ commit }, { email }) {
      try {
        const response = await axios.get(`/api/frontend/user/${email}`);
        commit('SET_USER_FRONTEND', response.data)
        commit('SET_USER_AUTHENTICATED', true)
        document.location.href = "/summary"
      } catch (error) {
        console.log(error);
        commit('SET_USER_FRONTEND', {})
        commit('SET_USER_AUTHENTICATED', false)
      }
    },
    async user_login_padel({ commit }, { email }) {
      try {
        const response = await axios.get(`/api/frontend/user/${email}`);
        commit('SET_USER_FRONTEND', response.data)
        commit('SET_USER_AUTHENTICATED', true)
        document.location.href = "/padel/summary"
      } catch (error) {
        console.log(error);
        commit('SET_USER_FRONTEND', {})
        commit('SET_USER_AUTHENTICATED', false)
      }
    },
    async user_login_single({ commit }, { email }) {
      try {
        const response = await axios.get(`/api/frontend/user/${email}`);
        commit('SET_USER_FRONTEND', response.data)
        commit('SET_USER_AUTHENTICATED', true)
        // router.push({ name: 'HomeUser' })
        // document.location.href = "/"
        router.push("/profile")
      } catch (error) {
        console.log(error);
        commit('SET_USER_FRONTEND', {})
        commit('SET_USER_AUTHENTICATED', false)
      }
    },
    guest({ commit }, { set_guest }) {
      commit('SET_GUEST', set_guest)
    },
    reset_user_guest({ commit }) {
      commit('SET_GUEST', {})
    },
    logout({ commit }) {
      commit('SET_USER', {})
      commit('SET_USER_FRONTEND', {})
      commit('SET_AUTHENTICATED', false)
      commit('SET_USER_AUTHENTICATED', false)
      localStorage.removeItem("authToken")
    },
    logout_member({ commit }) {
      commit('SET_USER_FRONTEND', {})
      commit('SET_USER_AUTHENTICATED', false)
      localStorage.removeItem("authToken")
    },
    logout_admin({ commit }) {
      commit('SET_USER', {})
      commit('SET_AUTHENTICATED', false)
      localStorage.removeItem("authToken")
    }
  }
}